import { CommentResponse } from 'models/comment';
import CommentItem from './CommentItems';
import { useState } from 'react';

interface CommentParentProps {
  comment: CommentResponse;
  gameId: string;
  getComments: () => void;
}

const CommentParent: React.FunctionComponent<CommentParentProps> = ({
  comment,
  gameId,
  getComments,
}) => {
  const [hideReply, setHideReply] = useState(true);

  const handleHideReply = (value: boolean) => {
    setHideReply(value);
  };

  return (
    <div className="comment">
      <CommentItem
        isParent
        setHideReply={handleHideReply}
        comment={comment}
        gameId={gameId}
        getComments={getComments}
        hideReply={hideReply}
      />
      {!hideReply && comment.reply.length > 0 && (
        <div className="comment-sub-list">
          {comment.reply
            .sort((a, b) => Date.parse(b.createdDate) - Date.parse(a.createdDate))
            .map((reply) => (
              <CommentItem
                isParent={false}
                comment={reply}
                gameId={gameId}
                hideReply={hideReply}
                getComments={getComments}
              />
            ))}
        </div>
      )}
    </div>
  );
};
export default CommentParent;
